import { defineStore } from "pinia";
import {
  WORKFLOW_STEPS as ASSESSMENT_WORKFLOW_STEPS,
  useAssessmentStore,
} from "./assessment";

export const useGlobalStore = defineStore("global", {
  state: () => ({
    config: null,
    testingMode: false,
    skipToAssessmentWorkflowStep: null,
  }),
  actions: {
    enableTestingMode() {
      if (!this.testingMode) {
        console.log("Testing mode enabled");

        this.testingMode = true;
      }
    },
    enablePrefillMode() {
      if (!this.prefillMode) {
        console.log("Prefill mode enabled");

        this.prefillMode = true;
      }
    },
    setSkipToAssessmentWorkflowStep(workflowStepIdentifier) {
      if (
        !workflowStepIdentifier ||
        ASSESSMENT_WORKFLOW_STEPS.includes(workflowStepIdentifier)
      ) {
        console.log(
          `Skipping to assessment workflow step: ${workflowStepIdentifier}`,
        );

        this.skipToAssessmentWorkflowStep = workflowStepIdentifier;

        return true;
      }

      console.warn(
        `Invalid assessment workflow step identifier: ${workflowStepIdentifier}. Valid steps are:`,
        ASSESSMENT_WORKFLOW_STEPS,
      );

      return false;
    },
  },
});
